module.exports = __webpack_public_path__ + "static/media/2.8084bc3b.jpg";